import React, { useEffect } from 'react';
// project import
import useConfig from 'hooks/useConfig';
import useAuth from 'hooks/useAuth';
import { Box, Tooltip } from "@mui/material";
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import { useIntl } from 'react-intl';
import IconButton from 'components/@extended/IconButton';
// import 'pages/createTemplateStyle/createTemplate.scss';
// import 'assets/third-party/react-table.css';
declare var $: any;
import { getDomainName } from 'utils/commonFunctions';
const domain = getDomainName();
const isIONetgate = domain === 'io-netgate.net' ? true :false;
const WCProfile: React.FC = () => {
  const { mode, i18n } = useConfig();
  const { logout  } = useAuth();
  const intl = useIntl();

  const loadScript = () => {
    return new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = import.meta.env.VITE_APP_WC_PROFILE!;
      // script.src = '/main.js';
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Script load error'));
      document.body.appendChild(script);
    });
  };
  loadScript()
  useEffect(() => {
    $('#webComponentsProfile').empty();
    const loadUserData = async () => {
      try {
        // let lang = i18n=='gr' ? 'de' : i18n;
        const profileData: any = { lang: i18n };

        const profileButton = document.createElement('profile-button');
        profileButton.setAttribute('profiledata', JSON.stringify(profileData));
        const content = document.getElementById('webComponentsProfile');
        if (content) {
          content.appendChild(profileButton);
        }
      } catch (error) {
        console.error('Failed to load user data', error);
      }
    };
      loadUserData();
  }, [mode, i18n]);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box
  sx={{
    ml: 0.75,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: 1
  }}
>
  {isIONetgate ? (
    <Tooltip title={intl.formatMessage({ id: `logout` })}>
      <IconButton
        size="medium"
        sx={{ color: "text.primary" }}
        onClick={handleLogout}
      >
        <LogoutOutlined />
      </IconButton>
    </Tooltip>
  ) : (
    <div className="menu-item webcomponent-profile">
      <span className="webComponetsHoverColor webprofileitem">
        <div>
          <div className="avatar">
            <div id="webComponentsProfile"></div>
          </div>
        </div>
      </span>
    </div>
  )}
</Box>);
};

export default WCProfile;
